/* esm.sh - applesauce-common@5.2.0/dist/observable/cast-stream */
export * from "/*applesauce-common@5.2.0/esnext/dist/observable/cast-stream.mjs";
